import {data_zaune} from '../../../assets/images/zaune/data_zaune';

const initialeStates = {
    data: data_zaune
}

const zauneReducer = (states = initialeStates, action) => {
    const copyOfState = {...states};

    switch (action.type) {
        //update modell
        case 'UPDATEMODELLZAUN':
            let modell_index = action.ev.index;
            let modell_img = action.ev.img;
            let modell_titel = action.ev.titel;
            let modell_form = action.ev.form;

            copyOfState.data.modell[0].index = modell_index;
            copyOfState.data.modell[0].img = modell_img;
            copyOfState.data.modell[0].titel = modell_titel;
            copyOfState.data.modell[0].form = modell_form;
        return copyOfState;

        //update muster
        case 'UPDATEMUSTERZAUN':
            let muster = action.ev;
            copyOfState.data.modell[0].muster = muster;
        return copyOfState;

         //update tab index
         case 'UPDATETABINDEXZAUN':
            let tab_index = action.ev;
            copyOfState.data.tabs[0].tab_index = tab_index;
        return copyOfState;

        //get index of modell
        case 'UPDATEMODELLINDEXZAUN':
            copyOfState.modell_index = action.ev;
        return copyOfState;

        //get index of modell type
        case 'UPDATEMODELLTYPEINDEXZAUN':
            copyOfState.modell_type_index = action.ev;
        return copyOfState;

        //update steps
        case 'UPDATESTEPSZAUN':
            let step_index = action.ev;
            let steps = copyOfState.data.steps[0];
            let visited_steps = copyOfState.data.steps[1].visited;
            let step_icons = document.querySelectorAll(".MuiStepIcon-root");

            copyOfState.data.steps[0][step_index] = true;
            copyOfState.data.steps[1].visited[step_index] = step_index;

            steps.forEach((elem, index) => {
                 if(elem === true) {
                    step_icons[index].classList.add('MuiStepIcon-active');
                 } else {
                    step_icons[index].classList.remove('MuiStepIcon-active');
                 }
            })

            copyOfState.data.steps[1].active_steps = visited_steps;
        return copyOfState;

        //update all visited steps
        case 'UPDATEALLVISITEDSTEPSZAUN':
            copyOfState.data.allVisitedSteps = true;
        return copyOfState;

        //update kind of dimension
        case 'DIMENSIONKINDZAUN':
            let dimension = action.ev;
            copyOfState.data.dimensions[0].dimension = dimension;

        return copyOfState;

        //update total dimension
        case 'UPDATETOTALWIDTHZAUN':
            let total_width_value = action.ev;
            let total_dimension = copyOfState.data.dimensions[0];

            if (!total_width_value) {
                let single_elements_total = total_dimension.single_fields.reduce((a, b) => Number(a) + Number(b.width), 0);
                let single_element_width = Number(total_dimension.single_width);
                total_dimension.total_dimension_width = single_elements_total + single_element_width;
            } else {
                total_dimension.total_dimension_width = total_width_value;
            }
        return copyOfState;

        //update height
        case 'UPDATEHEIGHTZAUN':
            let height_value = action.ev;
            let height_dimension = copyOfState.data.dimensions[0];
            height_dimension.total_dimension_height = height_value;
        return copyOfState;

        //update single total dimension
        case 'UPDATESINGLETOTALDIMENSIONZAUN':
            let kind_dimension = action.ev;
            copyOfState.data.dimensions[0].kind_dimension = kind_dimension;
        return copyOfState;

        //update dimension of single field
        case 'UPDATESINGLEDIMENSIONZAUN':
            let single_dimension_ident = action.ev.name;
            let single_dimension = copyOfState.data.dimensions[0];

            if (single_dimension_ident === 'singlewidth') {
                single_dimension.single_width = action.ev.value;
            } else {
                single_dimension.single_piece = action.ev.value;
            }
        return copyOfState;

        //add single field
        case 'ADDSINGLETEXTFIELDZAUN':
            let objectSingleField = {
                 width: '',
                 piece: '',
            }

            copyOfState.data.dimensions[0].single_fields =
            [...copyOfState.data.dimensions[0].single_fields, objectSingleField];
        return copyOfState;

        //update single dimension of every field
        case 'UPDATESINGLEFIELDDIMENSIONZAUN':
            let single_field = action.ev.name;
            let single_field_index = action.ev.index;

            if (single_field === 'singlewidth') {
                copyOfState.data.dimensions[0].single_fields[single_field_index].width = action.ev.value;
            } else {
                copyOfState.data.dimensions[0].single_fields[single_field_index].piece = action.ev.value;
            }
            copyOfState.data.dimensions[0].single_fields =
            [...copyOfState.data.dimensions[0].single_fields];
        return copyOfState;

        //delete single field
        case 'DELETESINGLEFIELDZAUN':
            let delete_index = action.ev;

            copyOfState.data.dimensions[0].single_fields =
            copyOfState.data.dimensions[0].single_fields.filter((elem, index) => index !== Number(delete_index));

        return copyOfState;

          //update kind of color
          case 'SELECTKINDOFCOLORZAUN':
            let kind_of_color = action.ev;
            copyOfState.data.colors[0].kind_of_color = kind_of_color;
        return copyOfState;

        //update color
        case 'SELECTCOLORZAUN':
            let color = action.ev.color;
            let color_index = action.ev.index;

            copyOfState.data.colors[0].color_index = color_index;
            copyOfState.data.colors[0].color = color;
            copyOfState.data.colors[0].wish_color = '';
        return copyOfState;

        //update wish color
        case 'SELECTWISHCOLORZAUN':
            let wish_color = action.ev;
            copyOfState.data.colors[0].wish_color = wish_color;
        return copyOfState;

        //update Zaunspitze
        case 'UPDATEZAUNSPITZEN':
            let spitze = action.ev.titel;
            let spitze_index = action.ev.index;
            copyOfState.data.spitzen[0].spitze = spitze;
            copyOfState.data.spitzen[0].index = spitze_index;
        return copyOfState;

        //update pfosten
        case 'UPDATEPFOSTENZAUN':
            let pfosten_ident_index = action.ev.ident_index;
            let pfosten_ident_name = action.ev.ident_name;
            let pfosten_ident_value = action.ev.value;

            if(pfosten_ident_name === 'pfostenwidth') {
                copyOfState.data.pfosten[0].pfosten_width = pfosten_ident_value;
            }
            if(pfosten_ident_index === '0') {
                copyOfState.data.pfosten[0].ispfosten = true;
                copyOfState.data.pfosten[0].iskappen = false;
            }
            else if(pfosten_ident_index === '1') {
                copyOfState.data.pfosten[0].ispfosten = false;
                copyOfState.data.pfosten[0].iskappen = true;
            }
        return copyOfState;

        //update kappen
        case 'UPDATEKAPPENZAUN':
            let kappe_titel = action.ev.titel;
            let kappe_index = action.ev.index;
            copyOfState.data.pfosten[0].kappe = kappe_titel;
            copyOfState.data.pfosten[0].kappe_index = kappe_index;
        return copyOfState;

        //update product to merkliste
        case 'UPDATEPRODUCTTOMERKLISTEZAUN':
            copyOfState.data.is_merkliste = !copyOfState.data.is_merkliste;
        return copyOfState;

        //update description
        case 'UPDATEDESCRIPTIONZAUN':
            let description = action.ev;
            copyOfState.data.data_description[0].description = description;
        return copyOfState;

        //select upload file
        case 'SELECTUPLOADDATAZAUN':
            const fileSize = action.ev.file.size;
            const bytesToMegaBytes = fileSize / (1024 ** 2);
            if (bytesToMegaBytes>5) {
                copyOfState.data.data_description[0].isUploadData = false;
            } else {
                let data_file = action.ev.file;
                copyOfState.data.data_description[0].file = data_file;
                copyOfState.data.data_description[0].isUploadData = true;
            }
        return copyOfState;

        case 'UPDATEEDITZAUN':
            copyOfState.data.isEdit = !copyOfState.data.isEdit;
        return copyOfState;

        default:
            return copyOfState;
    }

}

export default zauneReducer;